// extracted by mini-css-extract-plugin
export default {"title":"InvestmentAndInsurance_title__EoWn4","start":"InvestmentAndInsurance_start__Q3oWl"};